export default {
  ALLOWENCE: 'abono',
  VACATION: 'ferias',
  QUITTING: 'acerto_por_desligamento',
};
